export default "__VITE_PUBLIC_ASSET__cf094f64__"